import React, { Fragment, useState, useEffect } from "react";
import io from "socket.io-client";
import { Link, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getGifs, getGifsSearch } from "../../actions/gif";
import {
  getIndustryEpisodes,
  getIndustryEpisode,
} from "../../actions/industryofweek";

import LoggedInNav from "../layout/IME/LoggedInNav";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import IndustryEpisodesContainer from "../layout/IME/IndustryEpisodesContainer";
import IndustryOfWeekVideo from "../layout/IME/IndustryOfWeekVideo";
import IndustryImageDescriptionItem from "../layout/IME/IndustryImageDescriptionItem";
import IndustryPositionItem from "../layout/IME/IndustryPositionItem";

import IndustryChat from "../layout/IME/IndustryChat";
import TwoFARequest from "../layout/Innovators/TwoFARequest";
import GreenSpinner from "../../img/Green_Spinner.gif";

let socket;

const IndustryOfWeek = ({
  match,
  auth: { user, channelid, jobtitle, location, verified },
  isAuthenticated,
  getGifs,
  gif: { gifs, loading },
  getIndustryEpisodes,
  getIndustryEpisode,
  episode,
}) => {
  const ENDPOINT = "localhost:5000";

  const [showGIFs, setshowGIFs] = useState(false);
  const [gifSearch, setGifSearch] = useState(false);
  const [text, setText] = useState("");
  const [foundGif, setGif] = useState("");
  const [flipCard, setflipCard] = useState(false);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [room, setRoom] = useState(match.params.industryname);
  const [imeBotAvi, setimebotavi] = useState("Innovate_Me_logo_green.png");
  const [showChat, setShowChat] = useState(true);
  const [showAuthentication, setShowAuthentication] = useState(true);

  useEffect(() => {
    getGifs();
    getIndustryEpisodes();
    getIndustryEpisode(match.params.industryname);
    setRoom(match.params.industryname);
  }, [
    getGifs,
    getIndustryEpisode,
    getIndustryEpisodes,
    match.params.industryname,
    room,
  ]);

  useEffect(() => {
    if (user) {
      socket = io(ENDPOINT);

      socket.on("roomUsers", (room, users) => {});

      socket.emit("joinRoom", {
        imebotavi: imeBotAvi,
        channelid: user.channelid,
        avatar: user.avatar,
        firstname: user.firstname,
        lastname: user.lastname,
        room: match.params.industryname,
      });
    }

    return () => {
      if (socket) {
        socket.emit("leave");

        socket.disconnect();

        socket.off();
      }
    };
  }, [ENDPOINT, match.params.industryname, user, episode]);

  useEffect(() => {
    socket.on("message", (message) => {
      setMessages([...messages, message]);
    });
  }, [messages]);

  const sendMessage = (e) => {
    e.preventDefault();
    if (message || foundGif !== "") {
      socket.emit(
        "chatMessage",
        message,
        foundGif,
        user.firstname,
        user.lastname,
        user.avatar,
        room
      );
      setMessage("");
      setGif("");
      setshowGIFs(false);
    }
  };

  const maxLength = 100;

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {isAuthenticated && <LoggedInNav />}
      {!isAuthenticated && <LoggedOutNav />}
      {episode.episodesloading ? (
        <div className="profile-error">
          <img src={GreenSpinner} />
        </div>
      ) : (
        <div className={showChat ? "flex-only-alt" : "flex-no-chat"}>
          <div className="side-container border-right grey">
            <div className="episodes">
              <div className="episode-link-container">
                <h1 className="episodes-desc-border">
                  <i className="fas fa-ticket-alt green mr-5"></i>Episodes
                </h1>
              </div>
              {episode.episodes.map((episode) => (
                <div
                  className={
                    episode.industryname === match.params.industryname
                      ? "episodes-container-alt"
                      : "episodes-container"
                  }
                  key={episode._id}
                  industryname={episode.industryname}
                  onClick={() => {
                    getIndustryEpisode(match.params.industryname);
                  }}
                >
                  <Link to={`/industryofweek/${episode.industryname}`}>
                    <IndustryEpisodesContainer episode={episode} />
                  </Link>
                </div>
              ))}
            </div>
          </div>
          <div className="main-stream-content">
            <div className="video-chat">
              <IndustryOfWeekVideo episode={episode} showChat={showChat} />
              {!showChat && (
                <div className="showchaticon" onClick={() => setShowChat(true)}>
                  <i className="far fa-comment fa-2x green"></i>
                </div>
              )}
            </div>
            <div className="industry-company-section">
              <IndustryImageDescriptionItem episode={episode} />
            </div>
            <div className="positions-section">
              <IndustryPositionItem
                flipCard={flipCard}
                setflipCard={setflipCard}
                episode={episode}
              />
            </div>
            <div className="margin-top-alt"></div>
          </div>
          {showChat && (
            <IndustryChat
              maxLength={maxLength}
              messages={messages}
              message={message}
              setMessage={setMessage}
              gifs={gifs}
              setGif={setGif}
              foundGif={foundGif}
              showGIFs={showGIFs}
              setshowGIFs={setshowGIFs}
              gifSearch={gifSearch}
              setGifSearch={setGifSearch}
              sendMessage={sendMessage}
              text={text}
              setText={setText}
              episode={episode}
              setShowChat={setShowChat}
            />
          )}
        </div>
      )}
    </Fragment>
  );
};

IndustryOfWeek.propTypes = {
  auth: PropTypes.object.isRequired,
  getGifs: PropTypes.func.isRequired,
  getGifsSearch: PropTypes.func.isRequired,
  getIndustryEpisodes: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  gif: state.gif,
  episode: state.industryweek,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getGifs,
  getGifsSearch,
  getIndustryEpisodes,
  getIndustryEpisode,
})(IndustryOfWeek);
